import axios from 'axios'
// import qs from 'qs'
axios.defaults.withCredentials = true

var root = process.env.VUE_APP_API;

try {
  root = CONFIG.baseURL;
}
catch(error){
}


// const root = process.env.NODE_ENV == 'production' ? process.env.VUE_APP_API : process.env.VUE_APP_API

// console.info(root);
// console.log(process.env.NODE_ENV)
// console.log(process.env.VUE_APP_API)
// console.log(process.env.BASE_URL)
// console.log(window.location.href)
const instance = axios.create({
  withCredentials: true,
  baseURL: root,
  headers: {
    // 'Content-Type': 'application/json;charset=utf-8'
  }
})
// instance.interceptors.request.use(
//   config => {
//     const authorization = store.state.Authorization
//     if (authorization) {
//       config.headers.Authorization = authorization
//     }
//     return config
//   },
//   error => {
//     return Promise.reject(error)
//   }
// )
instance.interceptors.response.use(
  res => {
    // // 正常返回
    // if (res.status === 200 || res.status === 201) {
    //   res.data.status = 1
    // } else {
    //   res.data.status = 0
    // }
    return res
  },
  error => {
    // 异常返回
    if (error.response) {
      error.response.data = {
        status: 0,
        msg: error.response.data.msg
      }
      switch (error.response.status) {
        case 403:
          window.localStorage.removeItem('userID')
          window.localStorage.removeItem('userType')
          window.localStorage.removeItem('isLogin')
          window.localStorage.removeItem('userInfo')
          sessionStorage.clear()
          // window.location.href = '/'
          break
        case 401:
          window.localStorage.removeItem('userID')
          window.localStorage.removeItem('userType')
          window.localStorage.removeItem('isLogin')
          window.localStorage.removeItem('userInfo')
          sessionStorage.clear()
          // window.location.href = '/'
          return {error:'401'}
          break
        default:
          return error.response.data
      }
    }
  }
)

export const list_evaluations = params => {
  return instance.post('/xpest/console_v2/api/order/query_evaluations', params).then(res => res.data)
}

export const get_code_yz = params => {
  return instance.post('/xpest/console_v2/api/customer/phone_gen_verification_code?phone='+params.phone, params).then(res => res.data)
}

export const get_code_yz_submit = params => {
  return instance.post('/xpest/console_v2/api/customer/merge_customer_principal_switch_notification', params).then(res => res.data)
}

export const phone_register_for_business = params => {
  return instance.post('/xpest/console_v2/api/customer/phone_register_for_business', params).then(res => res.data)
}

export const caculate_order = params => {
  return instance.post('/xpest/console_v2/api/order/caculate_order/', params).then(res => res.data)
}

export const get_valid_service_time_list = params => {
  return instance.post('/xpest/console_v2/api/thridpart/zhuosi/dispatcher/predict', params).then(res => res.data)
}

// 获取二维码支付url
export const get_order_pay_info_of_qrcode = params => {
  return instance.post('/xpest/console_v2/api/order_paytment/get_order_pay_info_of_qrcode/', params).then(res => res.data)
}

//支付宝支付
export const get_order_pay_info_directly_of_zhifubao = params => {
  return instance.post('/xpest/console_v2/api/order_paytment/get_order_pay_info_directly_of_zhifubao?orderId=' + params.orderId, params).then(res => res.data)
}

//h5微信支付
export const get_order_pay_info_h5_of_wechat = params => {
  return instance.post('/xpest/console_v2/api/order_paytment/get_order_pay_info_h5_of_wechat?orderId=' + params.orderId).then(res => res.data)
}

export const get_orders_by_customerid = params => {   // 订单列表
  return instance.post('/xpest/console_v2/api/order/get_orders_by_customerid', params).then(res => res.data);
}

export const phone_register_for_douyin = params => { //ccbbA ccbbB
  return instance.post('/xpest/console_v2/api/customer/phone_register_for_douyin', params).then(res => res.data);
}

export const get_report_to_customer_by_orderid = params => {
  return instance.get('/xpest/console_v2/api/order/get_report_to_customer_by_orderid?orderId=' + params.orderId, {
    params: params.data
  })
}

export const get_url_link_for_product = params => {
  return instance.get('/xpest/console_v2/api/order/get_url_link_for_product?productId=' + params.productId, {
    params: params.data
  })
}



// WEBPACK FOOTER //
// ./src/api/api.js